import React from 'react';
import * as Buttons from '../../ui/buttons';
import EndorsementItem from './EndorsementItem';
import Ionicon from 'react-ionicons';

export const DisplayEndorsements = props => {
	const { pending, received, published, buttonHandlers, guestMode } = props,
		number_pending = pending ? pending.length : null,
		number_received = received && received.length,
		existsPending = pending && pending.length !== 0,
		existsReceived = received && received.length !== 0,
		existsPublished = published && published.length !== 0;

	return (
		<div className="profile-endorsements-body">
			{/*show when not in guestMode*/}
			{!guestMode && (
				<div>
					{/* <p className="p-tag section-visibility-info">Endorsements are common across all subscribed networks.</p> */}

					{existsPending && (
						<p className="p-tag endorsement-status-info">
							<span>
								<Ionicon icon="ion-ios-bell" />
							</span>
							You have not yet received a reply to {number_pending || null}{' '}
							endorsement request(s).
						</p>
					)}

					{existsReceived && (
						<p className="p-tag endorsement-status-info">
							<span>
								<Ionicon icon="ion-ios-bell" />
							</span>
							You have {number_received || null} endorsement(s) that are
							unpublished.
						</p>
					)}

					{(existsPublished || existsReceived || existsPending) && (
						<Buttons.EndorsementsButton
							handleEditing={buttonHandlers.handleEditing}
						/>
					)}
				</div>
			)}
			{/*/////////*/}
			{existsPublished && (
				<div className="published-endorsements-list">
					{published.map(endorsement => (
						<EndorsementItem
							key={endorsement.body.id}
							{...endorsement}
							hideButtonsFromMain
						/>
					))}
				</div>
			)}
		</div>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/endorsements/DisplayEndorsements.js